import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import Login from 'routes/login';
import useAuth from 'redux/auth';
import { actions } from 'redux/auth/slice';
import { authTokenSelector } from 'redux/auth/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { loadKey } from 'util/localstorage';
import AppRoute from 'routes/app';
import SITELINKS from 'constants/sitelinks';
import { initFaro } from 'util/faro';

const LoggedRoute = ({ token, ...otherProps }) => (
  <Route
    {...otherProps}
    render={(props) =>
      token ? <AppRoute {...props} /> : <Redirect to="/login" />
    }
  />
);

LoggedRoute.propTypes = {
  token: PropTypes.string,
};

LoggedRoute.defaultProps = {
  token: null,
};

const PublicRoute = ({
  component: ComponentToRender,
  token,
  ...otherProps
}) => (
  <Route
    {...otherProps}
    render={(props) =>
      token ? (
        <Redirect to={SITELINKS.packages.bySearchCode} />
      ) : (
        <ComponentToRender {...props} />
      )
    }
  />
);

PublicRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  token: PropTypes.string,
};

PublicRoute.defaultProps = {
  token: null,
};

const App = () => {
  useAuth();
  const [isTokenChecked, setIsTokenChecked] = useState(false);
  const dispatch = useDispatch();
  const token = useSelector(authTokenSelector);
  useEffect(() => {
    if (!token) {
      const tokenOnLocalStorage = loadKey('sessionToken');
      if (tokenOnLocalStorage) {
        dispatch(actions.rehydrate(tokenOnLocalStorage));
        dispatch(actions.fetchLoggedUser());
      }
    }
    setIsTokenChecked(true);
  }, [token, dispatch]);

  
  useEffect(() => {
    initFaro();
  }, []);

  if (!isTokenChecked) {
    return null;
  }
  return (
    <BrowserRouter>
      <Switch>
        <PublicRoute path="/login" token={token} exact component={Login} />
        <PublicRoute
          path="/recoverPassword"
          token={token}
          exact
          component={Login}
        />
        <PublicRoute
          path="/confirmRecovery"
          token={token}
          exact
          component={Login}
        />
        <LoggedRoute path="/" token={token} />
        <Redirect to="" />
      </Switch>
    </BrowserRouter>
  );
};

export default App;
